const types = {
  none: 0,
  owner: 1,
  admin: 2,
  agentMaster: 3,
  agent: 4,
  naturalPerson: 5,
  corporatePerson: 6
}

const enumerable = []
for (let type in types) {
  enumerable.push(types[type])
}

module.exports.types = enumerable
module.exports = types
